/**
 * @generated SignedSource<<55a69f45416a275e82fda7cb8ba205ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
      readonly stock: number;
    };
  }>;
  readonly " $fragmentType": "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection";
};
export type ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection$key = {
  readonly " $data"?: ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuOfferEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuOffer",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveryChannel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stock",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuOfferConnection",
  "abstractKey": null
};

(node as any).hash = "418cede93ab2e0a78d296a543b4fde60";

export default node;
